export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          关于我们
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 border border-secondary-200/60 rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-1">
                <h3 className="text-xl font-bold text-foreground-900 mb-4 font-heading">
                  五一黑料网 —— 做最懂吃瓜群众的爆料平台
                </h3>
                <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    五一黑料网成立于2023年，是国内领先的黑料吃瓜与瓜田爆料内容聚合平台。我们致力于为全网吃瓜群众提供最新、最全、最及时的黑料资讯服务，覆盖娱乐圈、网红圈、社会热点等多个领域。
                  </p>
                  <p>
                    我们的编辑团队由资深娱乐记者和互联网内容运营专家组成，7×24小时不间断追踪全网黑料热点，确保用户在五一黑料入口打开网站的第一时间就能看到最新爆料内容。
                  </p>
                  <p>
                    五一黑料网始终坚持"真实、快速、全面"的内容原则，所有爆料均经过多方核实。我们相信，吃瓜不仅是一种娱乐方式，更是公众对信息透明化的追求。未来，五一黑料网将继续深耕黑料内容领域，为全网用户提供更加优质的黑料吃瓜体验。
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 mt-6">
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg">
                      <i className="ri-user-star-line"></i>
                    </div>
                    <span>专业编辑团队</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg">
                      <i className="ri-verified-badge-line"></i>
                    </div>
                    <span>信息多方核实</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <div className="w-8 h-8 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-lg">
                      <i className="ri-shield-user-line"></i>
                    </div>
                    <span>隐私安全保障</span>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-64 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20illustration%20of%20newsroom%20and%20digital%20media%20team%20concept%2C%20abstract%20figures%20working%20on%20screens%2C%20warm%20red%20and%20amber%20lighting%2C%20professional%20atmosphere%2C%20modern%20digital%20art%20style%2C%20clean%20composition%2C%20high%20quality&width=600&height=500&seq=about-2026&orientation=portrait"
                  alt="五一黑料网编辑团队"
                  className="w-full h-auto rounded-xl object-cover"
                  width="600"
                  height="500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}